import { LOCAL_STORAGE_KEYS } from '../constants'
import { localStorageHelper } from './localStorageHelper'

export function isNotificationRead (notification) {
  return Boolean(notification?.readDateUtc)
}

export function normalizeNotificationsFromApi (apiNotifications) {
  return (apiNotifications || []).map((notification) => ({
    ...notification,
    read: isNotificationRead(notification)
  }))
}

export function sortNotificationsForDisplay (notifications) {
  return [...notifications].sort((a, b) => {
    if (a.read !== b.read) {
      return a.read ? 1 : -1
    }

    const dateA = new Date(a.sequenceDate || a.createdDate).getTime()
    const dateB = new Date(b.sequenceDate || b.createdDate).getTime()
    if (dateB !== dateA) {
      return dateB - dateA
    }

    return (b.notificationId || 0) - (a.notificationId || 0)
  })
}

export function countUnreadNotifications (notifications) {
  return notifications.filter((n) => !n.read).length
}

export function loadAdvisorNotificationsUnreadOnlyFilter () {
  const stored = localStorageHelper.tryLoad(LOCAL_STORAGE_KEYS.advisorNotificationsUnreadOnly)
  if (stored === null) {
    return true
  }
  return Boolean(stored)
}

export function storeAdvisorNotificationsUnreadOnlyFilter (unreadOnly) {
  localStorageHelper.tryStore(LOCAL_STORAGE_KEYS.advisorNotificationsUnreadOnly, unreadOnly)
}
